export const FETCH_ERROR = "Some errors happened, please retry!";
export const BOOKING_SUCCESS = "Book lesson successful!";
export const CANCEL_BOOKING_SUCCESS = "Cancel lesson successful!";
export const CHANGE_PASSWORD_SUCCESS = "Update Password successful!";
export const UPDATE_PROFILE_SUCCESS = "Update profile successful!";

export const RATING_SUCCESS = "Thank for your feedback!";
export const REQUEST_SUCCESS = "Thank for your request!";


export const FILL_NOTES = "Plesea fill note!";
export const FILL_REASON = "Please fill reason!";
export const FILL_RATING = "Please fill rate!";
export const FILL_FEEDBACK = "Please fill feedback!";
export const FILL_ALL = "Please fill all information!";
export const FILL_PASSWORD = "Password field must not empty!";
export const DIFFERENT_PASSWORD = "Old password must be different from new password!";
export const INCORRECT_PASSWORD = "Old password is not correct";
export const CONFIRM_PASSWORD = "Confirm password need to match";